export default function NewTempUsers(){
  return(
    <div>
      New Template Users coming soon!
    </div>
  );
}